import {
  AppBar,
  Toolbar
} from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import HomeSection from './HomeSection';
import KpiSection from './KpiSection';
import LogoSection from './LogoSection';
import NotificationSection from './NotificacionSection';
import ProfileSection from './ProfileSection';
import ToogleSection from './ToogleSection';
import RefreshToken from './components/RefreshToken';

import { DesktopOrTabletContainer, MobileContainer } from '../../../responsiveTools/ResponsiveContainers';

import './header.scss';
export default function Header() {

  const [opendDlgToken, setOpenDlgToken] = useState(false);
  // INICIO Chequeo Token
  // tiempo en milisegundos de ejecución de la verificación
  // const TIEMPO_MS_CHEQUEO = 30000;
  const TIEMPO_MS_CHEQUEO = 1000;
  // tiempo para mostrar alerta. Menor a este tiempo se mostrará el popup para renovar el token
  const DIF_TIEMPO_ALERTA = 60;

  let continuarSesion = true;
  let intervalo;

  const chequearToken = () => {    
    try {
      var fechaActual = moment.utc();
      var fechaToken = moment.utc(sessionStorage.getItem("accessTokenValidTo").toString());
      continuarSesion = (fechaToken.diff(fechaActual, 'seconds') > DIF_TIEMPO_ALERTA);
      if (!continuarSesion) {
        clearInterval(intervalo);
        setOpenDlgToken(true);
      }
    } catch {
      handleCloseDlgToken();
    }
  }

  useEffect(() => {
    intervalo = setInterval(chequearToken, TIEMPO_MS_CHEQUEO);
  }, []);

  const handleCloseDlgToken = () => {
    setOpenDlgToken(false);
    intervalo = setInterval(chequearToken, TIEMPO_MS_CHEQUEO);
  };
  // FIN Chequeo Token

  return (
    <>

      <DesktopOrTabletContainer>
        <AppBar position='static' className='app-bar'>
          <Toolbar disableGutters className='app-toolbar'>
            <div className='logo-container'>
              <ToogleSection />
              <LogoSection />
            </div>
            <div className='action-buttons-row'>
              <NotificationSection />
              <KpiSection disabled={true} />
              <div className='profile-chip'>
                <ProfileSection />
              </div>
            </div>
          </Toolbar>
        </AppBar>
      </DesktopOrTabletContainer>

      <MobileContainer>
        <AppBar className='app-bar mobile-app-bar' position='fixed' sx={{ top: 'auto', bottom: 0 }}>
          <Toolbar className='app-toolbar' disableGutters>
            <HomeSection />
            <NotificationSection />
            <KpiSection />
            <div className='mobile-toggle-container'>
              <ToogleSection />
            </div>
          </Toolbar>
        </AppBar>
      </MobileContainer>

      <RefreshToken
        id="termino-accept"
        keepMounted
        open={opendDlgToken}
        onClose={handleCloseDlgToken}
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        timerCheck={TIEMPO_MS_CHEQUEO}
      />
    </>
  );
};